<div class="ca-header__action">
    <button class="button__user"[caMenuTriggerFor]="menuUsuario">
        <ca-icon>account_circle</ca-icon>
        <div class="user-info">
            <span class="name">{{usuario?.txtNombre}}</span>
            <small class="badge" *ngIf="usuario?.txtUsuarioSuplantado">{{'MENU.PUBLICO.MENU_USUARIO.SUPLANTANDO' | translate}}{{usuario?.txtUsuarioSuplantado}}</small>
        </div>
    </button>

    <ca-menu #menuUsuario="caMenu">
        <!--<ca-menu-item (selected)="abrirModalSuplantar()" *ngIf="!usuario?.txtUsuarioSuplantado"><ca-icon>group</ca-icon>{{'MENU.PUBLICO.MENU_USUARIO.SUPLANTAR' | translate}}</ca-menu-item>-->
        <!--<ca-menu-item (selected)="finalizarSuplantacion()" *ngIf="usuario?.txtUsuarioSuplantado"><ca-icon>group_remove</ca-icon>{{'MENU.PUBLICO.MENU_USUARIO.FIN_SUPLANTAR' | translate}}</ca-menu-item>-->
        <ca-menu-item (selected)="logout()"><ca-icon>logout</ca-icon>{{'MENU.PUBLICO.MENU_USUARIO.LOGOUT' | translate}} </ca-menu-item>
    </ca-menu>
</div>